<template>
  <div class="room-create-pay-fee-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('roomCreatePayFee.title')" :subtitle="$t('roomCreatePayFee.page.subtitle')" />

    <div class="ds-panel">
      <!-- 表单区 -->
      <el-form ref="form" :model="roomCreatePayFeeInfo" label-width="120px" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('roomCreatePayFee.feeType')">
              <el-select v-model="roomCreatePayFeeInfo.feeTypeCd" class="w-full" @change="changeFeeTypeCd"
                :placeholder="$t('roomCreatePayFee.selectFeeType')">
                <template v-for="(item, index) in roomCreatePayFeeInfo.feeTypeCds">
                  <el-option :key="index" :label="item.name" :value="item.statusCd"
                    v-if="item.statusCd != '888800010017'">
                  </el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('roomCreatePayFee.feeItem')">
              <el-select v-model="roomCreatePayFeeInfo.configId" class="w-full" @change="roomCreatePayFeeIfOnceFee"
                :placeholder="$t('roomCreatePayFee.selectFeeItem')">
                <template v-for="(item, index) in roomCreatePayFeeInfo.feeConfigs">
                  <el-option :key="index" :label="item.feeName" :value="item.configId">
                  </el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('roomCreatePayFee.startTime')">
              <el-date-picker v-model="roomCreatePayFeeInfo.startTime" type="date" class="w-full" value-format="yyyy-MM-dd"
                :placeholder="$t('roomCreatePayFee.selectStartTime')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('roomCreatePayFee.endTime')">
              <el-date-picker v-model="roomCreatePayFeeInfo.endTime" type="date" class="w-full" value-format="yyyy-MM-dd"
                :placeholder="$t('roomCreatePayFee.selectEndTime')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-if="roomCreatePayFeeInfo.computingFormula == '4004'" :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('roomCreatePayFee.amount')">
              <el-input v-model="roomCreatePayFeeInfo.amount" :placeholder="$t('roomCreatePayFee.inputAmount')">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="roomCreatePayFeeInfo.computingFormula == '1102'" :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('roomCreatePayFee.rateCycle')">
              <el-input v-model="roomCreatePayFeeInfo.rateCycle"
                :placeholder="$t('roomCreatePayFee.inputRateCycle')">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="roomCreatePayFeeInfo.computingFormula == '1102'" :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('roomCreatePayFee.rate')">
              <el-input v-model="roomCreatePayFeeInfo.rate" :placeholder="$t('roomCreatePayFee.inputRate')">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-show="roomCreatePayFeeInfo.computingFormula == '1102'" :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('roomCreatePayFee.rateStartTime')">
              <el-date-picker v-model="roomCreatePayFeeInfo.rateStartTime" type="date" class="w-full"
                :placeholder="$t('roomCreatePayFee.selectRateStartTime')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('roomCreatePayFee.building')">
              <el-select v-model="roomCreatePayFeeInfo.floorId" class="w-full" @change="loadFloorRooms"
                :placeholder="$t('roomCreatePayFee.selectBuilding')">
                <el-option v-for="(item, index) in roomCreatePayFeeInfo.floors" :key="index" :label="item.floorNum"
                  :value="item.floorId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('roomCreatePayFee.roomState')">
              <el-checkbox-group v-model="roomCreatePayFeeInfo.roomState" @change="changeRoomState">
                <el-checkbox label="2001">{{ $t('roomCreatePayFee.occupied') }}</el-checkbox>
                <el-checkbox label="2003">{{ $t('roomCreatePayFee.delivered') }}</el-checkbox>
                <el-checkbox label="2005">{{ $t('roomCreatePayFee.decorated') }}</el-checkbox>
                <el-checkbox label="2004">{{ $t('roomCreatePayFee.vacant') }}</el-checkbox>
                <el-checkbox label="2006">{{ $t('roomCreatePayFee.rented') }}</el-checkbox>
                <el-checkbox label="2007">{{ $t('roomCreatePayFee.sold') }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('roomCreatePayFee.room')">
              <div v-show="roomCreatePayFeeInfo.rooms && roomCreatePayFeeInfo.rooms.length > 0">
                <el-checkbox v-model="checkAllRooms" @change="checkAll">
                  {{ $t('roomCreatePayFee.selectAll') }}
                </el-checkbox>
                <el-checkbox-group v-model="roomCreatePayFeeInfo.roomIds">
                  <el-checkbox v-for="(item, index) in roomCreatePayFeeInfo.rooms" :key="index" :label="item.roomId">
                    <span v-if="item.unitNum != '0'">{{ item.roomName }}</span>
                    <span v-else>{{ item.floorNum }}-{{ item.roomNum }}</span>
                    ({{ item.stateName }})
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div v-show="!roomCreatePayFeeInfo.rooms || roomCreatePayFeeInfo.rooms.length < 1" class="ds-text-muted">
                {{ $t('roomCreatePayFee.noRoom') }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 表单操作区 -->
      <div class="ds-form-actions">
        <el-button icon="el-icon-close" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="saveRoomCreatePayFee">
          {{ $t('common.submit') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getCommunityId, getDict } from '@/api/community/communityApi'
import {
  listFeeConfigs,
  queryFloors,
  queryRooms,
  saveRoomCreatePayFee
} from '@/api/fee/roomCreatePayFeeApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'RoomCreatePayFeeList',
  components: {
    DsPageHeader
  },
  data() {
    return {
      roomCreatePayFeeInfo: {
        feeTypeCds: [],
        feeConfigs: [],
        remark: '',
        floorId: '',
        communityId: '',
        feeTypeCd: '',
        configId: '',
        roomIds: [],
        rooms: [],
        hasTime: 'OFF',
        startTime: '',
        endTime: '2050-01-01',
        feeFlag: '',
        computingFormula: '',
        amount: '',
        rateCycle: '',
        rate: '',
        rateStartTime: '',
        roomState: ['2001', '2003', '2005', '2004', '2006', '2007'],
        floors: []
      },
      checkAllRooms: false
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      this.roomCreatePayFeeInfo.communityId = getCommunityId()
      await this.loadFeeTypeCds()
      await this.loadFloors()
    },
    async loadFeeTypeCds() {
      try {
        const data = await getDict('pay_fee_config', 'fee_type_cd')
        this.roomCreatePayFeeInfo.feeTypeCds = data.filter(item =>
          item.statusCd !== "888800010015" && item.statusCd !== "888800010016"
        )
      } catch (error) {
        console.error('Failed to load fee types:', error)
      }
    },
    async loadFloors() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.roomCreatePayFeeInfo.communityId
        }
        const { apiFloorDataVoList } = await queryFloors(params)
        this.roomCreatePayFeeInfo.floors = apiFloorDataVoList
      } catch (error) {
        console.error('Failed to load floors:', error)
      }
    },
    async changeFeeTypeCd(feeTypeCd) {
      if (feeTypeCd === '888800010006' || feeTypeCd === '888800010014') {
        this.roomCreatePayFeeInfo.startTime = new Date()
        this.roomCreatePayFeeInfo.endTime = this.addMonthDate(new Date(), 1)
      }
      this.roomCreatePayFeeInfo.configId = ''

      try {
        const params = {
          page: 1,
          row: 500,
          communityId: this.roomCreatePayFeeInfo.communityId,
          feeTypeCd: feeTypeCd,
          isDefault: 'F',
          valid: '1'
        }
        const { feeConfigs } = await listFeeConfigs(params)
        this.roomCreatePayFeeInfo.feeConfigs = feeConfigs
      } catch (error) {
        console.error('Failed to load fee configs:', error)
      }
    },
    async loadFloorRooms() {
      this.roomCreatePayFeeInfo.rooms = []
      this.roomCreatePayFeeInfo.roomIds = []

      if (!this.roomCreatePayFeeInfo.floorId) return

      try {
        const params = {
          page: 1,
          row: 500,
          communityId: this.roomCreatePayFeeInfo.communityId,
          floorId: this.roomCreatePayFeeInfo.floorId,
          roomState: this.roomCreatePayFeeInfo.roomState.join(',')
        }
        const { rooms } = await queryRooms(params)
        this.roomCreatePayFeeInfo.rooms = rooms
        if (rooms && rooms.length > 0) {
          this.roomCreatePayFeeInfo.roomIds = rooms.map(room => room.roomId)
        }
      } catch (error) {
        console.error('Failed to load rooms:', error)
      }
    },
    changeRoomState() {
      setTimeout(() => {
        this.loadFloorRooms()
      }, 1000)
    },
    roomCreatePayFeeIfOnceFee(configId) {
      if (this.roomCreatePayFeeInfo.feeTypeCd !== '888800010006' &&
        this.roomCreatePayFeeInfo.feeTypeCd !== '888800010014' &&
        this.roomCreatePayFeeInfo.feeFlag === '1003006') {
        this.roomCreatePayFeeInfo.endTime = ''
      }

      const config = this.roomCreatePayFeeInfo.feeConfigs.find(item => item.configId === configId)
      if (config) {
        this.roomCreatePayFeeInfo.feeFlag = config.feeFlag
        this.roomCreatePayFeeInfo.computingFormula = config.computingFormula
      }
    },
    checkAll(checked) {
      if (checked) {
        this.roomCreatePayFeeInfo.roomIds = this.roomCreatePayFeeInfo.rooms.map(room => room.roomId)
      } else {
        this.roomCreatePayFeeInfo.roomIds = []
      }
    },
    async saveRoomCreatePayFee() {
      if (!this.validate()) {
        this.$message.error(this.$t('roomCreatePayFee.validateError'))
        return
      }

      if (!this.roomCreatePayFeeInfo.roomIds || this.roomCreatePayFeeInfo.roomIds.length < 1) {
        this.$message.error(this.$t('roomCreatePayFee.noRoomSelected'))
        return
      }

      try {
        await saveRoomCreatePayFee(this.roomCreatePayFeeInfo)
        this.$message.success(this.$t('common.operationSuccess'))
        this.goBack()
      } catch (error) {
        this.$message.error(error.message || this.$t('common.saveFailed'))
      }
    },
    validate() {
      if (!this.roomCreatePayFeeInfo.configId) {
        return false
      }
      return true
    },
    goBack() {
      this.$router.go(-1)
    },
    addMonthDate(date, months) {
      const newDate = new Date(date)
      newDate.setMonth(newDate.getMonth() + months)
      return newDate
    }
  }
}
</script>

<style lang="scss" scoped>
.room-create-pay-fee-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色表单面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
}

.ds-form {
  padding: var(--ds-spacing-lg) var(--ds-spacing-lg) 0;

  ::v-deep .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }

  ::v-deep .el-form-item__label {
    color: var(--ds-gray-700);
    font-weight: 500;
  }

  .el-checkbox-group {
    margin-top: 10px;

    .el-checkbox {
      margin-right: 15px;
      margin-bottom: 10px;
    }
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding: var(--ds-spacing-md) var(--ds-spacing-lg);
  border-top: 1px solid var(--ds-gray-200);
}

/* 辅助文本 */
.ds-text-muted {
  color: var(--ds-gray-500);
  font-size: var(--ds-font-size-sm);
}
</style>
